import React, { useMemo, useCallback } from 'react';
import buildAccordionClickFunction from 'helper/buildAccordionClickFunction';

import Accordion from 'components/Accordion';
import RadioButton from 'components/DesignSystem/RadioButton';
import Snackbar from 'components/DesignSystem/Snackbar';
import useModels from 'hooks/Meteorology/Fields/TrackingForecast/DetailedView/useModel';

export default function Models() {
  const { models, selectedModel, setModel } = useModels();
  const closeAccordion = useMemo(() => buildAccordionClickFunction('models-accordion'), []);
  const setModelAndClose = useCallback((newModel : string) => {
    setModel(newModel);
    closeAccordion();
  }, [setModel, closeAccordion]);

  return (
    <Accordion.Item eventKey="models" id="models-accordion">
      <Accordion.Header>Modelo</Accordion.Header>
      <Accordion.Body>
        {models.length === 0 && (
          <Snackbar>Nenhum modelo disponível para a frequência temporal selecionada.</Snackbar>
        )}
        {models.map((model) => (
          <RadioButton
            key={model.id}
            label={model.label}
            checked={model.value === selectedModel?.value}
            onChange={() => setModelAndClose(model.value)}
            className="my-2"
          />
        ))}
      </Accordion.Body>
    </Accordion.Item>
  );
}
